import React from 'react'
import Config from 'config'
import { useTheme } from 'styled-components'
import { useTranslation } from 'react-i18next'
import { MaterialIcon } from '@dsny/dsny-component-library'

import {
  Wrapper,
  WrapperDetail,
  IconWrapper,
  IconCircle,
  NoReleaseTitle,
  ReleaseDetails,
  ReleaseSupport,
  ReleaseSupportDetails,
  ReleaseLink
} from './NoReleasesFilterView.styles'

const EmptyReleasesFilterView = () => {
  const theme = useTheme()
  const { t } = useTranslation()
  return (
    <Wrapper>
      <WrapperDetail>
        <IconWrapper>
          <IconCircle>
            <MaterialIcon
              name="MusicNoteOutlined"
              color={theme.colors.player40}
              style={{ height: '32px', width: '32px', fontSize: '32px' }}
            />
          </IconCircle>
        </IconWrapper>
        <NoReleaseTitle>{t('error.no-available-releases')}</NoReleaseTitle>
        <ReleaseDetails>{t('error.no-release-details')}</ReleaseDetails>
        <ReleaseSupport>
          <ReleaseSupportDetails>
            {t('error.no-release-persists')}
          </ReleaseSupportDetails>
          <ReleaseLink onClick={() => window.open(Config.endpoints.supportURL)}>
            {t('error.contact-support')}
          </ReleaseLink>
        </ReleaseSupport>
      </WrapperDetail>
    </Wrapper>
  )
}

export default EmptyReleasesFilterView
